import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * @param orgId {string}
 * @param [queryParams] {object}
 * @param [queryParams.id] {string|string[]}
 * @param [queryParams.org] {string|string[]}
 * @param [queryParams.project] {string|string[]}
 * @param [queryParams.planItem] {string|string[]}
 * @param [queryParams.status] {string|string[]}
 * @param [queryParams.startDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.endDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.archived] {boolean}
 * @param [queryParams.withArchived] {boolean}
 * @param [queryParams.select] {string|string[]}
 * @param [queryParams.limit] {number}
 * @param [queryParams.sortBy] {string}
 * @param [queryParams.sortDirection] {string}
 * @param [queryParams.updatedAt] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 */
export function getActions(queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/actions?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param orgId {string}
 * @param [queryParams] {object}
 * @param [queryParams.id] {string|string[]}
 * @param [queryParams.project] {string|string[]}
 * @param [queryParams.planItem] {string|string[]}
 * @param [queryParams.status] {string|string[]}
 * @param [queryParams.startDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.endDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.archived] {boolean}
 * @param [queryParams.withArchived] {boolean}
 * @param [queryParams.select] {string|string[]}
 * @param [queryParams.limit] {number}
 * @param [queryParams.sortBy] {string}
 * @param [queryParams.sortDirection] {string}
 * @param [queryParams.updatedAt] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 */
export function getOrgActions(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/orgs/${orgId}/actions?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param orgId {string}
 * @param [queryParams] {object}
 * @param [queryParams.id] {string|string[]}
 * @param [queryParams.project] {string|string[]}
 * @param [queryParams.planItem] {string|string[]}
 * @param [queryParams.status] {string|string[]}
 * @param [queryParams.startDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.endDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.archived] {boolean}
 * @param [queryParams.withArchived] {boolean}
 * @param [queryParams.sortBy] {string}
 * @param [queryParams.sortDirection] {string}
 * @param [queryParams.updatedAt] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 */
export function getOrgActionsLite(orgId, queryParams = {}, signal) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/orgs/${orgId}/actions/lite?${qs}`, { signal })
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param missionId {string}
 * @param [queryParams] {object}
 * @param [queryParams.id] {string|string[]}
 * @param [queryParams.planItem] {string|string[]}
 * @param [queryParams.status] {string|string[]}
 * @param [queryParams.startDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.endDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.archived] {boolean}
 * @param [queryParams.withArchived] {boolean}
 * @param [queryParams.select] {string|string[]}
 * @param [queryParams.limit] {number}
 * @param [queryParams.sortBy] {string}
 * @param [queryParams.sortDirection] {string}
 * @param [queryParams.updatedAt] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 */
export function getMissionActions(missionId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/missions/${missionId}/actions?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param missionId {string}
 * @param [queryParams] {object}
 * @param [queryParams.id] {string|string[]}
 * @param [queryParams.planItem] {string|string[]}
 * @param [queryParams.status] {string|string[]}
 * @param [queryParams.startDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.endDate] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 * @param [queryParams.archived] {boolean}
 * @param [queryParams.withArchived] {boolean}
 * @param [queryParams.limit] {number}
 * @param [queryParams.sortBy] {string}
 * @param [queryParams.sortDirection] {string}
 * @param [queryParams.updatedAt] {string} E.g. { date: 'eq 2025-07-25T00:00:00.000Z' }
 */
export function getMissionActionsLite(missionId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/missions/${missionId}/actions/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
